import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { EnvironmentProviders, makeEnvironmentProviders } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { AuthInterceptor } from "./auth/auth.interceptor";
import { ErrorInterceptor } from "./util/error.interceptor";
import { JsonDateInterceptor } from "./util/json-date.interceptor";
import { CompressionInterceptor } from "./compression/compression.interceptor";

/**
 * Provides core application services and interceptors
 */
export function provideCoreServices(): EnvironmentProviders {
  return makeEnvironmentProviders([
    // HTTP Interceptors
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CompressionInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JsonDateInterceptor, multi: true },

    // PrimeNG Services
    MessageService,
    ConfirmationService,
    DialogService,

    // HTTP Client with interceptors
    provideHttpClient(withInterceptorsFromDi()),
  ]);
}
